import { ApplicationRef, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone, OnInit, Output } from '@angular/core';
import { TypeaheadOptions } from 'ngx-bootstrap/typeahead';
import { ToastrService } from 'ngx-toastr';
import { AsyncSubject, BehaviorSubject, interval, Observable, of, timer } from 'rxjs';
import { ShopService } from '../../api/shop.service';
import { MyTidyPropsGroup, MyTidyStyleGroup } from '../../interfaces/custom/MyTidyBase';
import { HoverService } from '../../services/hover.service';
import { MyTidyConfigService } from '../../services/my-tidy-config.service';
import { StoreService } from '../../services/store.service';
import { ServizioMenuService } from '../../services/servizio-menu.service';

declare global {
  interface Window {
   _configService: MyTidyConfigService;
   _frameLoaded: AsyncSubject<boolean>;
   _dragAndDrop: BehaviorSubject<any>;
   _hoverService: HoverService
  }
}

@Component({
  selector: 'app-aside-edit',
  templateUrl: './aside-edit.component.html',
  styleUrls: ['./aside-edit.component.scss'],
})
export class AsideEditComponent implements OnInit {
  hoverService : HoverService;

  config : MyTidyConfigService;
  _config;

  props : MyTidyPropsGroup;
  styles : MyTidyStyleGroup[];
  componentClass;
  activeTab = 1;

  dragAndDrop;

  @Output() onDrag = new EventEmitter();

  constructor(private elementRef : ElementRef, private cdr : ChangeDetectorRef,
    private toastr : ToastrService, private store : StoreService, private shop : ShopService,
    private zone : NgZone, private servizioMenu: ServizioMenuService) {
    this.dragAndDrop = new BehaviorSubject(null);
    window._dragAndDrop = this.dragAndDrop;

    window._frameLoaded = new AsyncSubject();
    window._frameLoaded.subscribe(r => {
      this.config = window._configService;
      this.hoverService = window._hoverService;

      this.config.nextConfig$.subscribe(nextConfig => {
        if (nextConfig && nextConfig.class == this.componentClass)
          return;

        if (this.props)
          this.props.inEdit = false;
  
        if (nextConfig) {
          this.activeTab = 1;
          this.props = nextConfig.props;
          this.styles = nextConfig.styles;
          this._config = nextConfig.config;
          this.componentClass = nextConfig.class;
          
          this.props.inEdit = true;
          this.props.updateForm();
  
          for (let style of this.styles)
            style.updateForms();
        }
        else {
          try {
            this.props.inEdit = false;
          } catch (err) {}
          this.props = undefined;
          this.styles = undefined;
          this.componentClass = undefined;
          this.hoverService.clearActive();
        }

        // https://stackoverflow.com/questions/61712865/angular-click-event-handler-not-triggering-change-detection
        // fix problem with running change detection
        // run empty zone will trigger change detection in zone, so the (click) handler will bound to correct zone
        // and in further change detection will run on click as should be
        this.zone.run(() => {});
        
      });

    });

  }

  ngOnInit(): void {}

  close() {
    this.config.nextConfig$.next(null);
  }

  saveChanges() {
    if (this.props) {
      this.props.saveValue();

      for (let styleGroup of this.styles) {
        styleGroup.saveValues();
      }
    }
    this.config.saveConfig().subscribe(r => {
      alert('Modifiche salvate');
    },
    err => {
      alert('Errore')
    });
  }

  changeTab(tab) {
    this.activeTab = tab;
  }

  onDragStart(event, component) {
    event.dataTransfer.setData("text/plain", component);

    this.dragAndDrop.next("drag start");
    this.onDrag.emit('start');
  }

  onDragEnd(event) {
    this.dragAndDrop.next({
      mouse: {
        x: event.pageX,
        y: event.pageY
      }
    });

    this.onDrag.emit('end');
  }

  remove() {
    this.componentClass.remove();
    this.close();
  }

  items = {};

getItems(propKey) {
  if (!this.items.hasOwnProperty(propKey)) {
    this.items[propKey] = [];

    if (propKey === 'groups') {
      this.servizioMenu.getFamiglie().subscribe(r => {
        this.items[propKey] = r; 
      });
    }
  }

  return this.items[propKey];
}

}
